import { Component, Input } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { EvaluationType } from '@proxy/evaluations';

@Component({
    selector: 'app-evaluation-type-column',
    templateUrl: './evaluation-type-column.component.html',
    standalone: false
})
export class EvaluationTypeColumnComponent extends AppBaseComponent {
  @Input({ required: true }) evaluationType: EvaluationType;

  protected readonly EvaluationType = EvaluationType;
}
